import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import SignaturePad from "react-signature-canvas";
import { AccordionSection } from "./AccordionSection";
import { SectionErrors } from "./SectionErrors";
import { SignedImage } from "../../common/SignedImage";

export function CustomerSatisfactionSection({ jobToComplete, submitSatisfactionHandler, setError, errorMessage }) {
  const today = new Date();
  const [signatureUrl, setSignatureUrl] = useState(null);
  const dbSignatureDate = new Date(jobToComplete.completionDetail.customerSignatureDate);
  const sigCanvas = useRef({});

  useEffect(() => {
    if (signatureUrl != null && !jobToComplete.completionDetail.customerSatisfied) {
      submitSatisfactionHandler(signatureUrl);
    }
  }, [signatureUrl]);

  const clearCanvas = () => sigCanvas.current.clear();
  const saveCanvas = () => {
    if (sigCanvas.current.isEmpty()) {
      setError("customerSatisfaction", "noSignature", "Please sign the form before submitting");
    } else {
      setSignatureUrl(sigCanvas.current.getCanvas().toDataURL("image/png"));
    }
  };

  const isComplete = jobToComplete.completionDetail.customerSatisfied;

  return (
    <AccordionSection
      id="customerSatisfaction"
      headerId="headerCustSatisfaction"
      collapseId="collapseCustSatisfaction"
      number={1}
      title="Customer Satisfaction"
      isComplete={isComplete}
      startOpen={true}
    >
      <p className="text-muted mb-1">Engineer Note</p>
      <p className="text-muted">
        This satisfaction note must be signed by the customer on completion of the work. This signature will complete
        the customer agreement. If the customer is not present please contact us on 020 4614 2422
      </p>
      <p className="fw-bold">To be signed by customer</p>
      <p>
        By Signing, you agree that the job has been completed to your satisfaction and according to the contract.
      </p>
      <div className="form-group mb-3">
        <label htmlFor="name" className="text-muted">
          Customer Name
        </label>
        <input
          className="form-control"
          type="text"
          readOnly={true}
          id="name"
          value={`${jobToComplete.name.firstName} ${jobToComplete.name.lastName}`}
        />
      </div>
      <div className="form-group mb-3">
        <label htmlFor="signDate" className="text-muted">
          Date
        </label>
        <input
          className="form-control"
          type="text"
          readOnly={true}
          id="signDate"
          value={isComplete ? dbSignatureDate.toLocaleDateString() : today.toLocaleDateString()}
        />
      </div>
      <div className="form-group mb-3">
        <label htmlFor="signature" className="text-muted">
          Customer Signature
        </label>
        {!isComplete ? (
          <SignaturePad ref={sigCanvas} id="signature" canvasProps={{ className: "signatureCanvas" }} />
        ) : jobToComplete.completionDetail.customerSatisfactionSignature?.url ? (
          <SignedImage
            src={jobToComplete.completionDetail.customerSatisfactionSignature.url}
            className="signatureCanvas mb-2"
            disabled={true}
          />
        ) : null}
        <div className="d-flex flex-column flex-md-row justify-content-md-end gap-2 mt-2">
          <button className="btn btn-danger" onClick={clearCanvas} disabled={isComplete}>
            Clear Signature
          </button>
          <button className="btn btn-primary" onClick={saveCanvas} disabled={isComplete}>
            Submit Customer Satisfaction
          </button>
        </div>
        <SectionErrors errorMessage={errorMessage} section="customerSatisfaction" />
      </div>
    </AccordionSection>
  );
}

CustomerSatisfactionSection.propTypes = {
  jobToComplete: PropTypes.object.isRequired,
  submitSatisfactionHandler: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
  errorMessage: PropTypes.array.isRequired,
};
